var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState, useRef, useEffect } from 'react';
import get from 'lodash.get';
import styled from 'styled-components';
import Reveal from './Reveal';
import Notification from '../../Notification';
import getIcon from '../../utils/getIcon';
import StyledInfoIcon from '../StyledInfoIcon';
var InfoWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  .reveal-overlay {\n    height: ", ";\n    width: 100%;\n  }\n  .notification-icon {\n    display: none;\n  }\n"], ["\n  position: relative;\n  .reveal-overlay {\n    height: ",
    ";\n    width: 100%;\n  }\n  .notification-icon {\n    display: none;\n  }\n"])), function (_a) {
    var isInfoOpen = _a.isInfoOpen, wrapperHeight = _a.wrapperHeight;
    return isInfoOpen ? "calc(" + wrapperHeight + "px + 0.5rem)" : 'auto';
});
var InfoIconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: flex-start;\n  border: 1px solid transparent;\n  margin: 0.5rem 0;\n  padding: 0.25rem 0.5rem;\n  width: 2rem;\n  min-width: 2rem;\n  height: 2rem;\n  min-height: 2rem;\n  position: relative;\n  z-index: 2;\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: flex-start;\n  border: 1px solid transparent;\n  margin: 0.5rem 0;\n  padding: 0.25rem 0.5rem;\n  width: 2rem;\n  min-width: 2rem;\n  height: 2rem;\n  min-height: 2rem;\n  position: relative;\n  z-index: 2;\n"])));
var StyledCloseIcon = styled(getIcon('Cancel'))(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  min-width: 0.8125rem;\n  width: 0.8125rem;\n  min-height: 0.8125rem;\n  height: 0.8125rem;\n  cursor: pointer;\n  fill: #262729;\n  color: #262729;\n"], ["\n  min-width: 0.8125rem;\n  width: 0.8125rem;\n  min-height: 0.8125rem;\n  height: 0.8125rem;\n  cursor: pointer;\n  fill: #262729;\n  color: #262729;\n"])));
var InfoCloseWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: ", ";\n  justify-content: flex-end;\n  align-items: center;\n  align-self: flex-start;\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  margin-left: auto;\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  overflow: hidden;\n"], ["\n  display: ", ";\n  justify-content: flex-end;\n  align-items: center;\n  align-self: flex-start;\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  margin-left: auto;\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  overflow: hidden;\n"])), function (_a) {
    var isInfoOpen = _a.isInfoOpen;
    return (isInfoOpen ? 'flex' : 'block');
}, function (_a) {
    var isInfoOpen = _a.isInfoOpen;
    return (isInfoOpen ? '2rem' : '0');
}, function (_a) {
    var isInfoOpen = _a.isInfoOpen;
    return (isInfoOpen ? '2rem' : '0');
}, function (_a) {
    var isInfoOpen = _a.isInfoOpen;
    return (isInfoOpen ? '2rem' : '0');
}, function (_a) {
    var isInfoOpen = _a.isInfoOpen;
    return (isInfoOpen ? '2rem' : '0');
});
export var NotificationBox = function (_a) {
    var children = _a.children, revealPosition = _a.revealPosition;
    var _b = useState(false), isAnimating = _b[0], setIsAnimating = _b[1];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState(0), infoHeight = _d[0], setInfoHeight = _d[1];
    var infoWrapperRef = useRef(null);
    useEffect(function () {
        setInfoHeight(get(infoWrapperRef, 'current.clientHeight'));
    });
    return (React.createElement(InfoWrapper, { isInfoOpen: isOpen, wrapperHeight: infoHeight },
        React.createElement(Reveal, { onChange: function (event) {
                if (event.type === 'OPENED' || event.type === 'CLOSED') {
                    setIsAnimating(false);
                }
            }, speed: "fast", reveal: isOpen, revealContent: React.createElement("div", { ref: infoWrapperRef },
                React.createElement(Notification, { level: "info", isInline: true, content: React.createElement(React.Fragment, null, children) }),
                React.createElement(InfoCloseWrapper, { isInfoOpen: isOpen, onClick: function () {
                        if (!isAnimating) {
                            setIsAnimating(true);
                            setIsOpen(!isOpen);
                        }
                    } },
                    React.createElement(StyledCloseIcon, null))), revealPosition: revealPosition },
            React.createElement(InfoIconWrapper, { onClick: function () {
                    if (!isAnimating) {
                        setIsAnimating(true);
                        setIsOpen(!isOpen);
                    }
                } },
                React.createElement(StyledInfoIcon, { size: "1.5rem", color: "#fff" })))));
};
export default NotificationBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map